import { toast } from 'sonner';
import './ResetColumnsButton.css';

interface ResetFiltersButtonProps {
  disabled?: boolean;
  /** Column filters currently applied; the button is highlighted and counts them. */
  activeCount?: number;
  onReset: () => void;
}

export function ResetFiltersButton({ disabled = false, activeCount = 0, onReset }: ResetFiltersButtonProps) {
  const handleClick = () => {
    onReset();
    toast.success('Filters reset.');
  };
  const active = activeCount > 0;

  return (
    <button
      type="button"
      className={`sky-grid-reset-button${active ? ' sky-grid-reset-button--active' : ''}`}
      aria-label={active ? `Reset ${activeCount} column filter${activeCount === 1 ? '' : 's'}` : 'Reset column filters'}
      title={active ? 'Clear all column filters' : 'No column filters applied'}
      disabled={disabled}
      onClick={handleClick}
    >
      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M4 5h16l-6 7v5l-4 2v-7z" />
        <path d="m16 16 4 4" />
        <path d="m20 16-4 4" />
      </svg>
      Reset filters
      {active ? <span className="sky-grid-reset-button-count">{activeCount}</span> : null}
    </button>
  );
}
